import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { COURSE_FEATURE_KEY } from './keys';
import { courseReducer } from './reducers/course.reducer';
import { CourseEffects } from './effects/course.effects';
import { NextCourseBridge } from './bridges/next_course.bridge';

export const courseStoreProviders = [provideState(COURSE_FEATURE_KEY, courseReducer), provideEffects(CourseEffects, NextCourseBridge)];

export { CourseFacade } from './facades/course.facade';
export { courseCleanup } from './guards/cleanup.guard';
export * from './models';
export { courseActions } from './actions/course.actions';
